var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(`color:${_vm.val>0?'#f6465d':'#2ebd85'}`)},[_vm._v(" "+_vm._s(_vm.val>0?'+':'')+" "+_vm._s(_vm.val)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }